import Breadcrumb from './svg/Breadcrumb.svg'
import Button from './svg/Button.svg'
import Card from './svg/Card.svg'
import Checkbox from './svg/Checkbox.svg'
import CollectionEditor from './svg/CollectionEditor.svg'
import Container from './svg/Container.svg'
import Content from './svg/Content.svg'
import CustomBlock from './svg/CustomBlock.svg'
import CustomControl from './svg/CustomControl.svg'
import DatePicker from './svg/DatePicker.svg'
import Default from './svg/Default.svg'
import Dropdown from './svg/Dropdown.svg'
import Dropzone from './svg/Dropzone.svg'
import ErrorMessage from './svg/ErrorMessage.svg'
import Footer from './svg/Footer.svg'
import Grid from './svg/Grid.svg'
import GridLayout from './svg/GridLayout.svg'
import GridView from './svg/GridView.svg'
import Header from './svg/Header.svg'
import Image from './svg/Image.svg'
import Input from './svg/Input.svg'
import Label from './svg/Label.svg'
import Link from './svg/Link.svg'
import Menu from './svg/Menu.svg'
import Message from './svg/Message.svg'
import NumberFormat from './svg/NumberFormat.svg'
import PatternFormat from './svg/PatternFormat.svg'
import ProgressCircle from './svg/ProgressCircle.svg'
import ProgressLine from './svg/ProgressLine.svg'
import RadioGroup from './svg/RadioGroup.svg'
import Repeater from './svg/Repeater.svg'
import RichTextEditor from './svg/RichTextEditor.svg'
import Search from './svg/Search.svg'
import Sidebar from './svg/Sidebar.svg'
import Signature from './svg/Signature.svg'
import Sparks from './svg/Sparks.svg'
import StaticContent from './svg/StaticContent.svg'
import Tab from './svg/Tab.svg'
import TextArea from './svg/TextArea.svg'
import TimePicker from './svg/TimePicker.svg'
import Toggle from './svg/Toggle.svg'
import Tooltip from './svg/Tooltip.svg'
import TreePicker from './svg/TreePicker.svg'
import Uploader from './svg/Uploader.svg'

export const icons = {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  CollectionEditor,
  Container,
  Content,
  CustomBlock,
  CustomControl,
  DatePicker,
  Default,
  Dropdown,
  Dropzone,
  ErrorMessage,
  Grid,
  GridLayout,
  GridView,
  Image,
  Input,
  Label,
  Link,
  Footer,
  Header,
  Sidebar,
  Menu,
  Message,
  NumberFormat,
  PatternFormat,
  ProgressCircle,
  ProgressLine,
  RadioGroup,
  Repeater,
  RichTextEditor,
  Search,
  Signature,
  Sparks,
  StaticContent,
  Tab,
  TextArea,
  TimePicker,
  Toggle,
  Tooltip,
  TreePicker,
  Uploader
}
